var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 29,
    viewBox: "0 0 9 29",
    width: 9,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse",
    height: 29,
    width: 9,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f14836",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.991 19.459-.016-11.302a.61.61 0 0 0 -1.22-.005l.016 11.31.01 4.9c0 2.269-1.1 3.355-3.455 3.42-2.073-.09-3.1-1.218-3.1-3.445v-21a2.312 2.312 0 0 1 2.421-2.128 2.047 2.047 0 0 1 1.5.563 2.156 2.156 0 0 1 .664 1.588v15.722c0 1.627-.719 1.627-1.233 1.627-.443 0-1.27 0-1.27-1.419l.011-9.879s-.006-.6-.006-.592a.605.605 0 0 0 -1.21 0s-.017 10.471-.017 10.471a2.335 2.335 0 0 0 2.49 2.625c1.952 0 2.453-1.617 2.453-2.833v-15.723a3.346 3.346 0 0 0 -1.041-2.459 3.263 3.263 0 0 0 -2.369-.9 3.484 3.484 0 0 0 -3.614 3.34v21c0 2.839 1.572 4.534 4.312 4.651 3.036-.08 4.683-1.723 4.683-4.624z",
    fill: "#fff",
    fillRule: "evenodd",
    filter: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape-4.c0e5c34cdd5464cf10bc9613920a81f2.svg";
export { ForwardRef as ReactComponent };